module.exports = __webpack_public_path__ + "img/co-branding-logo-greggs.9b2818cc.png";